export default "__VITE_ASSET__tzghT3ZZ__"